module.exports = __webpack_public_path__ + "static/Abacus Bewerber aus Sicht des Portals-95710557f367048daa60ab958ab5eb22.png";